import { useState } from "react";
import { toast } from "sonner";
import { Field, Card, SaveButton, GhostButton, inputCls, areaCls } from "../ui";
import { adminFetch } from "../adminApi";

export default function FaqTab({ content, reload }) {
  const [draft, setDraft] = useState(() => JSON.parse(JSON.stringify(content.faq || [])));
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const update = (idx, key, value) =>
    setDraft((d) => d.map((f, i) => (i === idx ? { ...f, [key]: value } : f)));
  const remove = (idx) => setDraft((d) => d.filter((_, i) => i !== idx));
  const add = () => setDraft((d) => [...d, { id: `faq-${Date.now()}`, q: "Neue Frage", a: "Antwort …", active: true }]);
  const move = (idx, dir) =>
    setDraft((d) => {
      const copy = [...d];
      const j = idx + dir;
      if (j < 0 || j >= copy.length) return d;
      [copy[idx], copy[j]] = [copy[j], copy[idx]];
      return copy;
    });

  const save = async () => {
    setSaving(true);
    try {
      await adminFetch("/admin/content/faq", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(draft),
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
      await reload();
      toast.success("FAQ gespeichert – live auf der Website.");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <p className="text-sm text-zinc-400 leading-relaxed">
        Fragen und Antworten mit Sortierung: Die Reihenfolge hier entspricht der Website (Pfeile zum
        Verschieben). Inaktive Fragen bleiben erhalten, werden aber ausgeblendet.
      </p>

      {draft.map((f, idx) => (
        <Card
          key={f.id}
          title={f.q || `Frage ${idx + 1}`}
          actions={
            <div className="flex items-center gap-2">
              <button
                type="button"
                data-testid={`admin-faq-active-${f.id}`}
                onClick={() => update(idx, "active", f.active === false)}
                className={`h-9 rounded-full border px-4 text-xs font-semibold transition-colors ${
                  f.active === false
                    ? "border-zinc-700 text-zinc-400"
                    : "border-emerald-500/40 bg-emerald-500/10 text-emerald-400"
                }`}
              >
                {f.active === false ? "Inaktiv" : "Aktiv"}
              </button>
              <GhostButton onClick={() => move(idx, -1)} testid={`admin-faq-up-${f.id}`}>
                ↑
              </GhostButton>
              <GhostButton onClick={() => move(idx, 1)} testid={`admin-faq-down-${f.id}`}>
                ↓
              </GhostButton>
              <GhostButton danger onClick={() => remove(idx)} testid={`admin-faq-delete-${f.id}`}>
                Löschen
              </GhostButton>
            </div>
          }
        >
          <Field label="Frage">
            <input data-testid={`admin-faq-q-${f.id}`} className={inputCls} value={f.q || ""} onChange={(e) => update(idx, "q", e.target.value)} maxLength={300} />
          </Field>
          <Field label="Antwort">
            <textarea className={areaCls} value={f.a || ""} onChange={(e) => update(idx, "a", e.target.value)} maxLength={2000} />
          </Field>
        </Card>
      ))}

      <div className="sticky bottom-4 flex flex-wrap items-center gap-3 rounded-2xl border border-[#27272A] bg-[#0C0C0E]/95 p-4 backdrop-blur">
        <SaveButton onClick={save} saving={saving} saved={saved} testid="admin-save-faq" />
        <GhostButton onClick={add} testid="admin-faq-add">+ Frage hinzufügen</GhostButton>
        <GhostButton onClick={() => setDraft(JSON.parse(JSON.stringify(content.faq || [])))} testid="admin-reset-faq">
          Verwerfen
        </GhostButton>
      </div>
    </div>
  );
}
